
import { observer, inject } from 'mobx-react'
import React from 'react'
import PropTypes from 'prop-types'
import TempResponsiveScreen from '@components/TempResponsiveScreen'
import Spinner from '@root/components/spinner'
import SidePanel from '@root/Auth/Views/SidePanel'
import ZoomStreamGroup from './ZoomStreamGroup'
import Select from '@root/components/Select'


class ZoomStreamPage extends TempResponsiveScreen {
  static propTypes = {
    zoomRecordingStore: PropTypes.object,
    eplStore: PropTypes.object
  }

  componentDidMount() {
    //pathname = "/zoom-recording/eplHash/recordingId#type"
    const path = window.location.pathname.replace('/zoom-recording/', '')
    const eplHash = path.split('/')[0]
    const requestedRecordingId = path.split('/')[1]

    this.props.zoomRecordingStore.fetchRecordingAndStreamingURL(eplHash, requestedRecordingId)
  }

  render() {
    const { zoomRecordingStore } = this.props
    const { loading, recordings, epl } = zoomRecordingStore
    if (!recordings || !epl) return null

    const expertFullName = epl && epl.expert && epl.expert.fullName

    const groupOptions = recordings.map((group, index) => {
      const interviewDateTime = zoomRecordingStore.getRecordingGroupInterviewDateTime(group)
      return { value: index, label: interviewDateTime }
    })

    const selectedGroup = zoomRecordingStore.selectedGroup

    return (
      <div>
        {loading && (<Spinner />)}
        {!loading && (
          <div className='auth zoom-stream-page'>
            <SidePanel />
            <div className='content-container'>
              <h2>Interview Record</h2>
              <div className='field-container'>
                <span>Expert: </span>
                <span className='value'>{expertFullName}</span>
              </div>
              <div className='field-container'>
                <span>Interview Date / Time: </span>
                <Select
                  blue
                  value={selectedGroup}
                  options={groupOptions}
                  onChange={(e) => { zoomRecordingStore.setSelectedGroup(e.target.value) }}
                />
              </div>

              <ZoomStreamGroup
                zoomRecordingStore={this.props.zoomRecordingStore}
                recordings={recordings[selectedGroup]}
                eplStore={this.props.eplStore}
              />
            </div>
          </div>)}
      </div>
    )
  }
}

export default inject('zoomRecordingStore', 'eplStore')(observer(ZoomStreamPage))

